module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c520b140!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/scroll/src/index.vue
// module id = 313
// module chunks = 99 100